module.exports = __webpack_public_path__ + "static/media/pixr02.874ee62f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/pixr02.jpg
// module id = 39
// module chunks = 0